import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducer'
import AuthBaseApiSlice from '../api/AuthBaseApiSlice'
import { bookingApi } from '../modules/unauthenticated/booking/api/bookingApi'
import { devtools } from '../system/environment/Config.json'

const store = configureStore({
  reducer: rootReducer,
  devTools: devtools?.redux?.enabled,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(AuthBaseApiSlice.middleware, bookingApi.middleware)
})
export type RootState = ReturnType<typeof store.getState>
export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch
export default store
